import React from "react";
import MarketingSegments from "../../features/marketing-segments/MarketingSegments";

export default function MarketingSegmentsPage() {
  return (
    <div>
      <MarketingSegments />
    </div>
  );
}
